import {Component} from 'react';
import h from 'react-hyperscript';
import './Form.scss';
import {p, footnote, subhead} from 'Components/Typography/Typography';
import {withStyles} from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const styles = (theme) => ({
  root: {
    'color': '#80868b',
    '&:hover': {
      color: '#1a73e8',
    },
    '&$checked': {
      color: '#1a73e8',
    },
  },
  checked: {},
});

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: this.props.hasError,
      checked: this.props.checkedValues.length ? this.props.checkedValues.map(
          (item) => item.value
      ) : [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hasError !== this.props.hasError) {
      this.setHasError(this.props.hasError);
    }
  }

  checkIfValueExists() {
    if (this.props.checkedValues) {
      const array = this.props.checkedValues.map((item) => {
        return item.value;
      });
      this.setChecked(array);
    }
  }

  setChecked(value, checked = true) {
    const checkedList = this.state.checked;

    this.setState({
      checked: checked ?
      checkedList.concat([value]) :
        checkedList.filter((val) => val !== value),
    });
  }

  setHasError(value) {
    this.setState({
      hasError: value,
    });
  }

  render() {
    let errorClasses = 'error-message text--red hide-message';
    const {hasError} = this.state;
    if (hasError) {
      errorClasses += ' active show-message';
    }

    return (
      h('div', {
        className: 'form-group form-group__checkbox',
      },
      h(FormGroup, {
        id: this.props.id,
        className: 'priorityCheckboxes',
        step: this.props.step,
      }, [

        h(subhead, null, `${this.props.index}. ${this.props.title}`),

        h(footnote, {
          className: errorClasses,
        }, this.props.errorMessage),

        this.props.checkboxes.map((checkbox) => {
          const isChecked = this.state.checked.includes(checkbox.title);
          return (
            h(FormControlLabel, {
              key: checkbox.id,
              className: `margin-top--md padding-bottom--sm-2`,
              control: h(Checkbox, {
                id: this.props.id,
                name: this.props.id,
                value: checkbox.title,
                onChange: (e) => {
                  const currentTarget = e.currentTarget;
                  this.setChecked(currentTarget.value, currentTarget.checked);
                  this.props.onChange(e);
                },
                inputProps: {
                  datastep: this.props.step,
                },
                classes: {
                  root: this.props.classes.root,
                  checked: this.props.classes.checked,
                },
                checked: isChecked,
              }),
              label: h('div', null, [
                isChecked && hasError && h('span', {
                  className: 'material-icons text--red error-arrow',
                }, 'arrow_forward'),
                h(p, null, checkbox.title),
                h(footnote, {
                  className: 'text--grey',
                }, checkbox.desc),
              ]),
            })
          );
        }),
      ])
      )
    );
  }
}

export default withStyles(styles)(CheckboxGroup);
